/* KBM Fabrics — progressive enhancements
   v40: floating "Get a swatch first" CTA removed (swatch program on hold — do not promote).
        Free-shipping progress messaging removed (no free shipping rate exists at checkout).
        Drawer cross-sell prices/Add buttons now use the first non-swatch variant. */
(function(){
  'use strict';

  var UGC_PAGE = '/pages/get-featured';

  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];});}
  function money(c){return '$'+((c||0)/100).toFixed(2);}

  function setupUgcCarousel(){
    var grid=document.querySelector('.kbm-ugc-reviews__grid');
    if(!grid||grid.dataset.kbmCarousel==='1')return;
    grid.dataset.kbmCarousel='1';
    var wrap=document.createElement('div');wrap.className='kbm-ugc-wrap';
    grid.parentNode.insertBefore(wrap,grid);wrap.appendChild(grid);
    var l=document.createElement('button');l.className='kbm-ugc-arrow left';l.innerHTML='‹';l.type='button';l.setAttribute('aria-label','Previous video');
    var r=document.createElement('button');r.className='kbm-ugc-arrow right';r.innerHTML='›';r.type='button';r.setAttribute('aria-label','Next video');
    wrap.appendChild(l);wrap.appendChild(r);
    function step(){var c=grid.querySelector('.kbm-ugc-card');return c?c.offsetWidth+24:304;}
    l.addEventListener('click',function(){grid.scrollBy({left:-step(),behavior:'smooth'});});
    r.addEventListener('click',function(){grid.scrollBy({left:step(),behavior:'smooth'});});
    function u(){l.style.opacity=grid.scrollLeft>8?'1':'0.35';r.style.opacity=grid.scrollLeft<(grid.scrollWidth-grid.clientWidth-8)?'1':'0.35';}
    grid.addEventListener('scroll',u);u();
  }

  function setupInventoryUrgency(){
    if(!document.body.classList.contains('template-product'))return;
    var m=location.pathname.match(/\/products\/([^/?#]+)/);if(!m)return;
    fetch('/products/'+m[1]+'.js').then(function(r){return r.json();}).then(function(p){
      var inv=(p.variants||[]).reduce(function(s,v){return s+(typeof v.inventory_quantity==='number'?v.inventory_quantity:0);},0);
      if(inv>0&&inv<=15){
        var a=document.querySelector('.product-price-row');if(!a||document.querySelector('.kbm-stock-urgency'))return;
        var d=document.createElement('div');d.className='kbm-stock-urgency';d.textContent='Only '+inv+' yard'+(inv===1?'':'s')+' left';
        a.parentNode.insertBefore(d,a.nextSibling);
      }
    }).catch(function(){});
  }

  function setupYardTooltip(){
    var labels=document.querySelectorAll('.product-form-group label');
    for(var i=0;i<labels.length;i++){
      var label=labels[i];
      if((label.textContent||'').trim().toLowerCase()!=='quantity')continue;
      if(label.querySelector('.kbm-yd-info'))return;
      var info=document.createElement('span');info.className='kbm-yd-info';info.setAttribute('tabindex','0');info.setAttribute('aria-label','1 yard equals 36 inches. Cuts are continuous.');
      label.appendChild(document.createTextNode(' '));label.appendChild(info);return;
    }
  }

  function setupSavedEmptyCTA(){
    if(!/\/pages\/saved-fabrics/i.test(location.pathname))return;
    var t=0;var iv=setInterval(function(){t++;
      var e=document.getElementById('kbm-wishlist-empty');
      if(!e||e.style.display==='none'){if(t>30)clearInterval(iv);return;}
      if(e.querySelector('.kbm-empty-cta')){clearInterval(iv);return;}
      var c=document.createElement('div');c.className='kbm-empty-cta';
      c.innerHTML='<p>Save fabrics you love by tapping the heart on any product. They will show up here.</p><a href="/collections/best-sellers">Browse Best Sellers</a>';
      e.appendChild(c);clearInterval(iv);
    },200);
  }

  function fixMegaMenuLinks(){
    document.querySelectorAll('a[href="/collections/all-fabrics"]').forEach(function(a){
      var t=(a.textContent||'').trim();
      if(t==='Closeout Deals')a.href='/collections/last-cuts-1';
      if(t==='Wholesale')a.href='/pages/wholesale';
    });
  }

  function relocateMakersUse(){
    if(!document.body.classList.contains('template-product'))return;
    var m=document.querySelector('.kbm-makers-use');if(!m||m.dataset.kbmMoved==='1')return;
    var c=document.querySelector('.kbm-product');var l=document.querySelector('.product-layout');if(!c||!l)return;
    l.parentNode.insertBefore(m,l.nextSibling);m.dataset.kbmMoved='1';
  }

  function setupQualitativeBadges(){
    if(!document.body.classList.contains('template-product'))return;
    var m=location.pathname.match(/\/products\/([^/?#]+)/);if(!m)return;
    var titleEl=document.querySelector('.product-info h1');if(!titleEl)return;
    if(document.querySelector('.kbm-qbadge-row'))return;
    fetch('/products/'+m[1]+'.js').then(function(r){return r.json();}).then(function(p){
      var badges=[];
      var tags=(p.tags||[]).map(function(t){return String(t).toLowerCase();});
      var inv=(p.variants||[]).reduce(function(s,v){return s+(typeof v.inventory_quantity==='number'?v.inventory_quantity:0);},0);
      var publishedDate=p.published_at?new Date(p.published_at):null;
      var twoWeeksAgo=Date.now()-14*24*60*60*1000;
      if(tags.indexOf('new')>=0||(publishedDate&&publishedDate.getTime()>twoWeeksAgo)){badges.push({cls:'kbm-qb--new',label:'🆕 Just dropped'});}
      if(tags.indexOf('best-seller')>=0||tags.indexOf('bestseller')>=0||tags.indexOf('customer-favorite')>=0||tags.indexOf('favorite')>=0){badges.push({cls:'kbm-qb--fave',label:'⭐ Customer favorite'});}
      if(tags.indexOf('trending')>=0||tags.indexOf('selling-fast')>=0||tags.indexOf('fast-mover')>=0){badges.push({cls:'kbm-qb--fast',label:'🔥 Selling fast'});}
      if(inv>0&&inv<=5){badges.push({cls:'kbm-qb--low',label:'⚠️ Almost gone'});}
      if(!badges.length)return;
      var row=document.createElement('div');row.className='kbm-qbadge-row';
      row.innerHTML=badges.map(function(b){return '<span class="kbm-qbadge '+b.cls+'">'+b.label+'</span>';}).join('');
      var vendor=titleEl.parentNode.querySelector('.product-vendor');
      var anchor=vendor||titleEl;
      anchor.parentNode.insertBefore(row,anchor);
    }).catch(function(){});
  }

  /* ===== Fix UGC widget: route to /pages/get-featured + add a clear submit button ===== */
  function fixUgcLinks(){
    if(!document.body.classList.contains('template-product'))return;
    document.querySelectorAll('.kbm-ugc-submit a').forEach(function(a){
      if(a.href.indexOf('/pages/submit-your-make')>-1||a.href.indexOf('/pages/get-featured')>-1){a.href=UGC_PAGE;}
      if(a.classList.contains('kbm-ugc-submit__btn')){a.href=UGC_PAGE;a.textContent='Submit your make';}
    });
  }

  /* ===== Pinterest Save button on PDPs ===== */
  function setupPinterestSave(){
    if(!document.body.classList.contains('template-product'))return;
    if(/\/products\/kbmfabrics-swatches/i.test(location.pathname))return;
    var media=document.querySelector('.product-main-image');
    if(!media||media.querySelector('.kbm-pin-btn'))return;
    var img=media.querySelector('img');if(!img)return;
    var titleEl=document.querySelector('.product-info h1');
    var title=titleEl?titleEl.textContent.trim():document.title;
    var pageUrl=encodeURIComponent(location.origin+location.pathname);
    var imgUrl=encodeURIComponent(img.src.replace(/_\d+x(\d+x|\d+)?/,'_1200x'));
    var desc=encodeURIComponent(title+' | KBM Fabrics');
    var pinUrl='https://pinterest.com/pin/create/button/?url='+pageUrl+'&media='+imgUrl+'&description='+desc;
    var btn=document.createElement('a');
    btn.className='kbm-pin-btn';
    btn.href=pinUrl;
    btn.target='_blank';
    btn.rel='noopener noreferrer';
    btn.setAttribute('aria-label','Save to Pinterest');
    btn.title='Save to Pinterest';
    btn.innerHTML='<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.746-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12.017 24c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641.001 12.017.001z"/></svg>';
    media.appendChild(btn);
  }

  function setupCartDrawer(){
    var drawer=document.getElementById('kbmDrawer');
    if(!drawer)return;
    var items=drawer.querySelector('[data-drawer-items]');
    var empty=drawer.querySelector('[data-drawer-empty]');
    var foot=drawer.querySelector('[data-drawer-foot]');
    var countEl=drawer.querySelector('[data-cart-count]');
    var subtotalEl=drawer.querySelector('[data-drawer-subtotal]');
    var shippingEl=drawer.querySelector('[data-shipping-progress]');
    function open(){drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';loadCart();}
    function close(){drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');document.body.style.overflow='';}
    function render(cart){
      countEl.textContent=cart.item_count;
      document.querySelectorAll('.cart-count, .cart-badge, [data-cart-count], #kbmCartBadge').forEach(function(el){el.textContent=cart.item_count;if(cart.item_count>0)el.style.display='';});
      /* v40: free-shipping progress bar removed — no free shipping rate exists at checkout, so promising one was false advertising. */
      if(shippingEl)shippingEl.hidden=true;
      if(cart.item_count===0){empty.style.display='';items.hidden=true;foot.hidden=true;return;}
      empty.style.display='none';items.hidden=false;foot.hidden=false;
      items.innerHTML=cart.items.map(function(item){
        var img=item.featured_image&&item.featured_image.url?item.featured_image.url:(item.image||'');
        var props='';if(item.properties){for(var k in item.properties){if(k.charAt(0)==='_')continue;props+='<div class="kbm-drawer__prop">'+esc(k)+': '+esc(item.properties[k])+'</div>';}}
        return '<li class="kbm-drawer__item" data-key="'+esc(item.key)+'">'+
          '<a href="'+esc(item.url)+'" class="kbm-drawer__item-img"><img src="'+esc(img)+'" alt="" loading="lazy"></a>'+
          '<div class="kbm-drawer__item-info">'+
            '<a href="'+esc(item.url)+'" class="kbm-drawer__item-title">'+esc(item.product_title)+'</a>'+
            (item.variant_title&&item.variant_title!=='Default Title'?'<div class="kbm-drawer__item-variant">'+esc(item.variant_title)+'</div>':'')+
            props+
            '<div class="kbm-drawer__item-bottom">'+
              '<div class="kbm-drawer__qty">'+
                '<button type="button" data-qty-change="-1" aria-label="Decrease">−</button>'+
                '<input type="number" value="'+item.quantity+'" min="0" data-qty-input>'+
                '<button type="button" data-qty-change="1" aria-label="Increase">+</button>'+
              '</div>'+
              '<div class="kbm-drawer__item-price">'+money(item.final_line_price)+'</div>'+
            '</div>'+
          '</div>'+
          '<button type="button" class="kbm-drawer__remove" data-remove aria-label="Remove">×</button>'+
        '</li>';
      }).join('');
      subtotalEl.textContent=money(cart.total_price);
    }
    function loadCart(){return fetch('/cart.js').then(function(r){return r.json();}).then(render).catch(function(){});}
    function changeQty(key,qty){return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();}).then(render).catch(function(){});}
    drawer.addEventListener('click',function(e){
      if(e.target.matches('[data-drawer-close]')||e.target.closest('[data-drawer-close]')){close();return;}
      if(e.target.matches('[data-drawer-close-on-click]')){setTimeout(close,100);return;}
      var ch=e.target.closest('[data-qty-change]');
      if(ch){var li=ch.closest('[data-key]');var inp=li.querySelector('[data-qty-input]');var nq=Math.max(0,(parseInt(inp.value,10)||0)+parseInt(ch.dataset.qtyChange,10));inp.value=nq;changeQty(li.dataset.key,nq);return;}
      var rm=e.target.closest('[data-remove]');
      if(rm){var li2=rm.closest('[data-key]');changeQty(li2.dataset.key,0);return;}
    });
    drawer.addEventListener('change',function(e){var inp=e.target.closest('[data-qty-input]');if(!inp)return;var li=inp.closest('[data-key]');changeQty(li.dataset.key,Math.max(0,parseInt(inp.value,10)||0));});
    document.addEventListener('click',function(e){
      var link=e.target.closest('a[href="/cart"], a[href$="/cart"]');
      if(link&&!e.metaKey&&!e.ctrlKey&&!e.shiftKey&&link.target!=='_blank'){e.preventDefault();open();}
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer.classList.contains('is-open'))close();});
    document.addEventListener('submit',function(e){
      var form=e.target;if(!form.matches('form[action*="/cart/add"]'))return;
      e.preventDefault();var fd=new FormData(form);var btn=form.querySelector('[type="submit"]');var orig=btn?btn.textContent:null;
      if(btn){btn.disabled=true;btn.textContent='Adding...';}
      fetch('/cart/add.js',{method:'POST',body:fd}).then(function(r){if(!r.ok)throw new Error('fail');return r.json();}).then(function(){
        if(btn){btn.disabled=false;btn.textContent=orig||'Add to Cart';}
        open();
      }).catch(function(){if(btn){btn.disabled=false;btn.textContent=orig||'Add to Cart';}form.submit();});
    });
    window.KBMCart={open:open,close:close,refresh:loadCart};
    window.kbmRefreshCartDrawer=loadCart;
    loadCart();
  }

  function init(){
    setupUgcCarousel();setupInventoryUrgency();
    setupYardTooltip();setupSavedEmptyCTA();fixMegaMenuLinks();
    relocateMakersUse();setupQualitativeBadges();fixUgcLinks();setupPinterestSave();setupCartDrawer();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else setTimeout(init,100);
  document.addEventListener('shopify:section:load',init);
})();

/* ============================================
   Cart Drawer Cross-Sell ("People also bought")
   ============================================ */
(function(){
  var STATE = { lastProductId: null, loaded: false };

  function inject(){
    var existing = document.getElementById('kbm-drawer-crosssell-css');
    if(existing) return;
    var s = document.createElement('style');
    s.id = 'kbm-drawer-crosssell-css';
    s.textContent = ''
      + '.kbm-drawer__crosssell{padding:18px 16px 8px;border-top:1px solid rgba(0,0,0,0.08);background:#fdf8f0;}'
      + '.kbm-drawer__crosssell-head{font-family:"Playfair Display",Georgia,serif;font-size:15px;font-weight:700;color:#1a1a2e;margin:0 0 12px;letter-spacing:-0.01em;}'
      + '.kbm-drawer__crosssell-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:10px;}'
      + '.kdx-card{display:flex;flex-direction:column;background:#fff;border:1px solid rgba(0,0,0,0.06);border-radius:10px;overflow:hidden;text-decoration:none;color:inherit;transition:transform .15s,box-shadow .15s;}'
      + '.kdx-card:hover{transform:translateY(-2px);box-shadow:0 6px 16px rgba(0,0,0,0.08);}'
      + '.kdx-img{width:100%;aspect-ratio:1/1;object-fit:cover;background:#f0ebe2;}'
      + '.kdx-body{padding:8px 10px 10px;display:flex;flex-direction:column;gap:4px;flex:1;}'
      + '.kdx-title{font-size:11px;font-weight:600;color:#1a1a1a;margin:0;line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}'
      + '.kdx-price{font-size:11px;font-weight:700;color:#333;margin:0;}'
      + '.kdx-add{margin-top:6px;padding:6px 10px;background:#1a1a1a;color:#fff;border:none;border-radius:6px;font-size:10px;font-weight:700;letter-spacing:0.6px;text-transform:uppercase;cursor:pointer;transition:background .12s;}'
      + '.kdx-add:hover{background:#DC2F2F;}'
      + '.kdx-add:disabled{opacity:0.6;cursor:wait;}';
    document.head.appendChild(s);
  }

  function pickFirstCartProductId(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){
        if(!c.items || !c.items.length) return null;
        return c.items[0].product_id;
      });
  }

  function fetchRecs(productId){
    return fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(d){ return (d && d.products) || []; })
      .catch(function(){ return []; });
  }

  function money(cents){ return '$' + (parseInt(cents,10)/100).toFixed(2); }
  function escapeHtml(s){ return (s||'').replace(/[&<>"']/g, function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }

  /* v40: never anchor price or Add button to a Swatch/Sample variant */
  function pickVariant(p){
    var all = p.variants || [];
    var nonSwatch = all.filter(function(v){
      var t = (v.title||'').toLowerCase();
      return t.indexOf('swatch') === -1 && t.indexOf('sample') === -1;
    });
    var avail = nonSwatch.filter(function(v){ return v.available !== false; });
    return avail[0] || nonSwatch[0] || all[0] || null;
  }

  function render(products, container, wrapper){
    if(!products.length){ wrapper.setAttribute('hidden',''); return; }
    var html = products.map(function(p){
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var v = pickVariant(p);
      var variantId = (v && v.id) || '';
      var cents = (v && v.price != null) ? v.price : p.price;
      return ''
        + '<div class="kdx-card">'
        + '<a href="' + p.url + '" style="text-decoration:none;color:inherit;display:block;">'
        + (img ? '<img class="kdx-img" src="' + img + '" alt="" loading="lazy">' : '<div class="kdx-img"></div>')
        + '<div class="kdx-body">'
        + '<p class="kdx-title">' + escapeHtml(p.title) + '</p>'
        + '<p class="kdx-price">' + money(cents) + '/yd</p>'
        + '</div>'
        + '</a>'
        + '<button class="kdx-add" type="button" data-kdx-add data-variant="' + variantId + '">Add</button>'
        + '</div>';
    }).join('');
    container.innerHTML = html;
    wrapper.removeAttribute('hidden');
    // Wire add buttons
    container.querySelectorAll('[data-kdx-add]').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var vid = btn.getAttribute('data-variant');
        if(!vid) return;
        btn.disabled = true; btn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({id: vid, quantity: 1})
        }).then(function(r){ return r.json(); }).then(function(){
          btn.textContent = 'Added';
          // Refresh drawer if a global refresher exists
          if(typeof window.kbmRefreshCartDrawer === 'function'){ window.kbmRefreshCartDrawer(); }
          else { window.location.reload(); }
        }).catch(function(){
          btn.disabled = false; btn.textContent = 'Add';
        });
      });
    });
  }

  function refreshCrosssell(){
    inject();
    var wrapper = document.querySelector('[data-drawer-crosssell]');
    var grid = document.querySelector('[data-drawer-crosssell-grid]');
    if(!wrapper || !grid) return;
    pickFirstCartProductId().then(function(pid){
      if(!pid){ wrapper.setAttribute('hidden',''); STATE.lastProductId = null; return; }
      if(pid === STATE.lastProductId && STATE.loaded) return;
      STATE.lastProductId = pid;
      STATE.loaded = true;
      fetchRecs(pid).then(function(products){
        // Filter swatches and t-shirts
        var filtered = products.filter(function(p){
          var h = (p.handle || '').toLowerCase();
          var t = (p.title || '').toLowerCase();
          if(h.indexOf('swatch') !== -1) return false;
          if(h === 'kbm-slub-jersey-t-shirt') return false;
          if(t.indexOf('t-shirt') !== -1 && t.indexOf('jersey knit') === -1) return false;
          return true;
        }).slice(0,4);
        render(filtered, grid, wrapper);
      });
    });
  }

  // Listen for drawer open events (multiple triggers since the drawer may use various patterns)
  function onDrawerOpen(){
    setTimeout(refreshCrosssell, 80);
  }
  document.addEventListener('click', function(e){
    var target = e.target;
    // Cart icon clicks, ATC clicks (which usually open the drawer)
    if(target.closest && (
      target.closest('[data-kbm-cart-toggle]') ||
      target.closest('.kbm-cart-toggle') ||
      target.closest('[data-cart-toggle]') ||
      target.closest('a[href="/cart"]') ||
      target.closest('button[name="add"]') ||
      target.closest('.product-add-btn') ||
      target.closest('.kbm-quick-add')
    )){
      onDrawerOpen();
    }
  });
  // Also re-evaluate when cart drawer becomes visible via mutation observer
  document.addEventListener('DOMContentLoaded', function(){
    var drawer = document.querySelector('.kbm-cart-drawer, [data-cart-drawer], .cart-drawer');
    if(!drawer) return;
    var mo = new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        if(m.attributeName === 'class' || m.attributeName === 'aria-hidden' || m.attributeName === 'hidden'){
          if(drawer.classList.contains('is-open') || drawer.getAttribute('aria-hidden') === 'false' || !drawer.hasAttribute('hidden')){
            onDrawerOpen();
          }
        }
      });
    });
    mo.observe(drawer, {attributes:true});
  });
})();
